import { Component, OnInit } from '@angular/core';
import { VersionService } from '../../../core/services/version/version.service';
import { AlertController, Platform } from '@ionic/angular';
import { LibraryService } from '../../../core/services/library/library.service';

@Component({
    selector: 'app-app-disabled',
    templateUrl: './app-disabled.component.html',
    styleUrls: ['./app-disabled.component.scss'],
})
export class AppDisabledComponent implements OnInit {
    constructor(
        private versionService: VersionService,
        private platform: Platform,
        private alertCtrl: AlertController,
        private libraryService: LibraryService
    ) {}

    async ngOnInit(): Promise<any> {
        const alert = await this.alertCtrl.create({
            mode: this.platform.is('android') ? 'md' : 'ios',
            backdropDismiss: false,
            message: this.libraryService.getLabel('lbl_update_version_app'),
            buttons: this.platform.is('android')
                ? [
                      {
                          text: this.libraryService.getLabel(
                              'lbl_go_to_market_md'
                          ),
                          handler: () => {
                              this.goToMarket();
                              return false;
                          },
                      },
                  ]
                : [],
        });
        await alert.present();
    }

    goToMarket() {
        this.versionService.goToMarket();
    }
}
